angular.module('shared').directive('longEmailWrapper', function() {
  return {
    restrict: 'E',
    scope: {
      email: '='
    },
    template: `<span style="display: flex; flex-wrap: wrap;">
  <span ng-repeat="component in emailComponents">{{component}}</span>
</span>`,
    controller: ["$scope", function($scope) {
      var getEmailComponents, splitBySymbol;
      splitBySymbol = function(email, symbol) {
        if (Array.isArray(email)) {
          return email.map(function(item) {
            return splitBySymbol(item, symbol);
          });
        } else {
          return email.split(symbol).map(function(item, index) {
            if (index > 0) {
              return `${symbol}${item}`;
            } else {
              return item;
            }
          });
        }
      };
      getEmailComponents = function(email) {
        var components;
        components = splitBySymbol(email, '@');
        components = splitBySymbol(components, '+');
        components = splitBySymbol(components, '.');
        return $scope.emailComponents = _.flatten(components);
      };
      return $scope.$watch('email', function(email) {
        return getEmailComponents(email || '');
      });
    }]
  };
});
